import React from 'react';
import { Link } from 'react-router-dom';
import PageHero from '../../components/PageHero';
import { IconPin } from '../../components/Icons';
import './ServicePage.css';

export default function ServicePage({ data }) {
  const { icon, title, subtitle, category, norm, desc, details, related = [] } = data;
  const isMining = category === 'mineria';
  const catPath  = isMining ? '/servicios/mineria' : '/servicios/ambiental';
  const catLabel = isMining ? 'Minería' : 'Ambiental';

  return (
    <div>
      <PageHero
        label={catLabel}
        title={title}
        subtitle={subtitle}
        variant={isMining ? 'green' : 'blue'}
      />

      <section className="section">
        <div className="container sp-layout">
          {/* Main content */}
          <div className="sp-main">
            <div className="sp-overview">
              <div className={`sp-icon-wrap sp-icon-wrap--${isMining ? 'green' : 'blue'}`}>{icon}</div>
              <div>
                <div className="divider" style={{ background: isMining ? 'var(--c-green-500)' : 'var(--c-blue-500)' }} />
                <h2>Descripción del servicio</h2>
                <p>{desc}</p>
              </div>
            </div>

            <div className="sp-scope">
              <h3>Alcance y entregables</h3>
              <div className="sp-scope__grid">
                {details.map((d) => (
                  <div className={`sp-scope-item sp-scope-item--${isMining ? 'green' : 'blue'}`} key={d}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <circle cx="8" cy="8" r="8" fill={isMining ? 'var(--c-green-100)' : 'var(--c-blue-100)'} />
                      <path d="M5 8l2 2 4-4" stroke={isMining ? 'var(--c-green-600)' : 'var(--c-blue-600)'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>{d}</span>
                  </div>
                ))}
              </div>
            </div>

            {related.length > 0 && (
              <div className="sp-related">
                <h3>Servicios relacionados</h3>
                <div className="sp-related__grid">
                  {related.map(r => (
                    <Link to={r.path} className="sp-related-card" key={r.label}>
                      <span className="sp-related-card__icon">{r.icon}</span>
                      <span>{r.label}</span>
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M4 2l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Sidebar */}
          <aside className="sp-sidebar">
            <div className="sp-cta-box">
              <h3>¿Necesita este servicio?</h3>
              <p>Solicite una cotización personalizada. Nuestro equipo analizará sus requerimientos en detalle.</p>
              <Link to="/contacto" className={`btn btn--${isMining ? 'primary' : 'blue'} btn--lg`} style={{width:'100%',justifyContent:'center',marginBottom:'10px'}}>
                Solicitar cotización
              </Link>
              <Link to="/contacto" className="btn btn--ghost-white" style={{width:'100%',justifyContent:'center',background:'rgba(0,0,0,0.06)',color:'inherit',borderColor:'var(--c-gray-200)'}}>
                Hablar con un especialista
              </Link>
            </div>

            <div className="sp-norm-box">
              <div className="sp-norm-box__icon"><IconPin size={20} /></div>
              <h4>Marco normativo</h4>
              <p>{norm}</p>
            </div>

            <div className="sp-nav-box">
              <p className="sp-nav-box__label">Ver todos los servicios</p>
              <Link to={catPath} className="btn btn--outline" style={{width:'100%',justifyContent:'center'}}>
                {catLabel}
              </Link>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
}
